import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=4a0bc5ec&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=4a0bc5ec&prod&lang=scss&scoped=true"
import style1 from "./Slider.vue?vue&type=style&index=1&id=4a0bc5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bc5ec",
  null
  
)

export default component.exports